const DEFAULT_UOM = process.env.REACT_APP_USER_DEFAULT_UNIT_OF_MEASURE_OVERRIDE || "IMPERIAL";
const DEFAULT_LANGUAGE = process.env.REACT_APP_USER_DEFAULT_LOCALE_OVERRIDE || "EN_US";

const getSettingValue = (state, key) => {
    const setting = state.data.settings[key];
    return setting && setting.value;
};

export default {

    loading: (state) => state.data.settings.loading,

    hasSetting: (state, key) => state.data.settings[key] !== undefined,

    getSettingValue,

    getSetting: (state, key) => state.data.settings[key],

    error: (state) => state.data.settings.error,

    unitOfMeasure: (state) => (getSettingValue(state, 'user.general.unitOfMeasure') || DEFAULT_UOM),
    
    language: (state) => (getSettingValue(state, 'user.general.locale') || DEFAULT_LANGUAGE),

    settingsLoaded: (state) => {
        let allAreLoaded = true;
        if (state.data.settings['user.general.unitOfMeasure'] === undefined) {
            allAreLoaded = false;
        }
        if (state.data.settings['user.general.locale'] === undefined) {
            allAreLoaded = false;
        }
        return allAreLoaded;
    }
};
